import { fetchPath } from "./fetch-path";

export function isGif(src?: string): src is string {
  if (!src) return false;

  return /\.(gif)$/.test(fetchPath(src));
}
